import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { VERTICALS } from "@/data/content";

const Card = ({ v, index }) => (
  <motion.article
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.2 }}
    transition={{ duration: 0.6, delay: (index % 2) * 0.1 }}
    data-testid={`vertical-card-${index}`}
    tabIndex={0}
    className="group relative h-[340px] overflow-hidden rounded-3xl outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2"
  >
    <img
      src={v.image}
      alt={v.title}
      className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03] group-focus-visible:scale-[1.03]"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-ink/75 via-ink/15 to-transparent" />
    <div
      data-testid={`vertical-card-reveal-gradient-${index}`}
      className="pointer-events-none absolute inset-x-0 bottom-0 h-3/4 bg-gradient-to-t from-ink/90 via-ink/45 to-transparent opacity-0 transition-opacity duration-500 ease-out group-hover:opacity-100 group-focus-visible:opacity-100"
    />
    <div className="absolute inset-x-0 bottom-0 p-6 lg:p-7">
      <h3 data-testid={`vertical-card-title-${index}`} className="font-heading text-xl font-semibold text-white lg:text-2xl">
        {v.title}
      </h3>
      <p
        data-testid={`vertical-card-description-${index}`}
        className="mt-0 max-h-0 max-w-lg translate-y-2 overflow-hidden text-sm leading-relaxed text-white/80 opacity-0 transition-[opacity,transform,max-height,margin-top] duration-500 ease-out group-hover:mt-2 group-hover:max-h-24 group-hover:translate-y-0 group-hover:opacity-100 group-focus-visible:mt-2 group-focus-visible:max-h-24 group-focus-visible:translate-y-0 group-focus-visible:opacity-100"
      >
        {v.title === "Cold Storage & Food Processing" ? (
          <>
            Maintain critical refrigeration and processing loads through
            <br className="hidden lg:block" /> grid interruptions.
          </>
        ) : (
          v.detail
        )}
      </p>
    </div>
  </motion.article>
);

export const Verticals = () => (
  <section id="verticals" data-testid="verticals-section" className="bg-baseLight px-6 py-[30px] sm:py-[40px] lg:px-12 lg:py-[70px]">
    <div className="lg:max-w-[1280px] lg:mx-auto">
      <div className="mb-10 flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
        <h2 className="max-w-2xl font-heading text-[30px] sm:text-[35px] lg:text-[41px] font-semibold text-ink leading-tight">
          Built around real agricultural energy needs
        </h2>
        <Link
          to="/applications"
          data-testid="verticals-cta"
          className="group flex shrink-0 items-center gap-1.5 text-sm font-medium text-teal hover:text-tealHover transition-colors duration-300"
        >
          Explore All Applications
          <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5" />
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        {VERTICALS.map((vertical, index) => (
          <Card key={vertical.title} v={vertical} index={index} />
        ))}
      </div>
    </div>
  </section>
);
